const CALENDLY_URL = 'https://paystack.com/buy/private-clarity-call-sdonrr';

const includes = [
  'Bespoke sessions with Mandie',
  'Clinical assessment and personalised healing plan',
  'Somatic and psychological tools tailored to you',
  'Support between sessions',
  'Full clinical confidentiality',
];

export default function Offer1Section() {
  return (
    <section className="bg-[#FDFAF8] py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-12">
          {/* Left — Text */}
          <div className="lg:col-span-3">
            {/* Eyebrow */}
            <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4">
              The most intimate container
            </p>

            {/* Headline */}
            <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#1A1A1A] mb-6 leading-tight">
              Just you. Just Mandie. Just the truth.
            </h2>

            {/* Body */}
            <p className="font-body text-sm md:text-base text-[#4A4A4A] leading-relaxed mb-8">
              Private sessions designed entirely around you, your history, your patterns, your wounds, your becoming. No template. No programme. Just two women in a room, one holding the other as she finds her way back to herself.
            </p>

            {/* Includes */}
            <ul className="space-y-3 mb-8">
              {includes.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-[#C9A84C] mt-2 flex-shrink-0" />
                  <span className="font-body text-sm text-[#4A4A4A]">{item}</span>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 bg-[#D4006A] text-white text-sm font-body font-medium rounded-full hover:bg-[#B3005A] transition-colors duration-300 w-full sm:w-auto"
            >
  Book a Clarity Call
</a>
<p className="text-xs text-[#4A4A4A] mt-2">
  <a href="https://paystack.com/buy/private-clarity-call-sdonrr" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#D4006A]">Book a Private Clarity Call</a>
</p>
          </div>

          {/* Right — Image */}
          <div className="lg:col-span-2 flex items-center justify-center">
            <div className="w-full max-w-[320px] mx-auto lg:max-w-none aspect-[4/5] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20intimate%20therapy%20room%20bathed%20in%20soft%20golden%20sunlight%2C%20cream%20linen%20armchair%20with%20throw%20blanket%20in%20earthy%20terracotta%20tones%2C%20gentle%20shadows%20from%20sheer%20curtains%2C%20ceramic%20vase%20with%20dried%20pampas%20grass%20on%20wooden%20side%20table%2C%20peaceful%20healing%20sanctuary%20interior%2C%20editorial%20photography%20with%20soft%20natural%20lighting%20and%20warm%20neutral%20earth-tone%20color%20palette%2C%20serene%20safe%20atmosphere%2C%20high%20detail%20harmonious%20composition&width=600&height=750&seq=offer1-coaching-2026-v2&orientation=portrait"
                alt="One-on-one private coaching session with Mandie Ozee"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}